<template>
    <div class="assign-card">
        <form @submit.prevent="assign" class="main-form">
            <custom-input
                v-model="requestParams.FromExternalId"
                :title="$t('ACCOUNT_CARDS__FROM_ID')"
                inputType="number"
                isRequired
                helperText="* Required"
                @clear="requestParams.FromExternalId = ''"
            />
            <custom-input
                v-model="requestParams.ToExternalId"
                :title="$t('ACCOUNT_CARDS__TO_ID')"
                inputType="number"
                isRequired
                helperText="* Required"
                @clear="requestParams.ToExternalId = ''"
            />
            <custom-select
                v-model="webShopId"
                :options="webShopOptions"
                :title="$t('ACCOUNT_CARDS__WEB_SHOP')"
                @clear="webShopId = ''"
            />
            <switcher v-model="activate" :title="$t('ACCOUNT_CARDS__ACTIVATE')" />
            <button class="btn">{{ $t('ACCOUNT_CARDS__ASSIGN') }}</button>
        </form>
        <grid
            v-if="dataCount > 0"
            :fullGrid="true"
            :passedData="gridData"
            identificator="id"
            :columns="columns"
            :passedCount="dataCount"
            :passedPageSize="15"
            :title="$t('ACCOUNT_CARDS__ASSIGNED_CARDS')"
            @pageChanged="pageChangeHandler"
        ></grid>
        <div class="btn export" v-if="dataCount > 0" @click="exportData">
            <span>{{ $t('ACCOUNT_CARDS__EXPORT') }}</span>
            <i class="material-icons">cloud_download</i>
        </div>
        <custom-snackbar
            v-if="snackbar.visible"
            :text="snackbar.text"
            :purpose="snackbar.purpose"
            @close="snackbar.visible = false"
        />
    </div>
</template>

<script>
import CustomInput from '@/components/ReusableComponents/CustomInput/CustomInput.vue'
import CustomSelect from '@/components/ReusableComponents/CustomSelect/CustomSelect.vue'
import Switcher from '@/components/ReusableComponents/Switcher/Switcher.vue'
import Grid from '@/components/ReusableComponents/Grid/Grid.vue'
import CustomSnackbar from '@/components/ReusableComponents/CustomSnackbar/CustomSnackbar.vue'
import axios from '@/Helpers/AxiosInstance.js'
import { exportToExcel } from '@/Helpers/HelperFunctions.js'
export default {
    components: {
        CustomInput,
        CustomSelect,
        Switcher,
        CustomSnackbar,
        Grid,
    },
    props: {
        columns: Array,
        webShopOptions: Array,
        getCardsURL: {
            type: String,
            default: 'WebShop/FilterAccountCards'
        },
        assignCardsURL: {
            type: String,
            default: 'WebShop/AssignAccountCardsToWebShop'
        }

    },
    data() {
        return {
            webShopId: '',
            activate: true,
            requestParams: {
                FromInternalId: '',
                ToInternalId: '',
                Assigned: null,
                Activated: null,
                Locked: null,
                WebShopId: '',
                FromExternalId: '',
                ToExternalId: '',
                OrderColumn: '',
                OrderDirection: '',
                CurrentPage: 1,
                PageSize: 15,
            },
            snackbar: {
                visible: false,
                text: '',
                purpose: '',
            },
            dataCount: 0,
            gridData: null,
        }
    },
    methods: {
        assign() {
            axios
                .post(this.assignCardsURL, {
                    externalIdFrom: this.requestParams.FromExternalId,
                    externalIdTo: this.requestParams.ToExternalId,
                    webShopId: this.webShopId,
                    activate: this.activate,
                })
                .then(resp => {
                    if (resp.data.status == 1) {
                        this.snackbar.text = 'Assigned Successfully!'
                        this.snackbar.purpose = 'success'
                        this.snackbar.visible = true
                        this.$emit('expand')
                        this.getData()
                    } else {
                        this.showError(resp.data.status)
                    }
                })
                .catch(() => this.showError())
        },
        showError(status) {
            this.snackbar.text = 'An Error Occured While Assigning!'
            this.snackbar.purpose = 'error'
            this.snackbar.visible = true
            var code = this.statusCodes.filter(e => e.key == status)[0]
            if (code) this.snackbar.text = this.$t('STATUS-CODE__' + code.value)
        },
        pageChangeHandler(page) {
            this.requestParams.CurrentPage = page
            this.getData()
        },
        getData() {
            axios
                .get(this.getCardsURL, {
                    params: { ...this.requestParams },
                })
                .then(resp => {
                    this.gridData = resp.data.response
                    this.dataCount =
                        resp.data.response.length > 0
                            ? resp.data.response[0].count
                            : 0
                })
        },
        exportData() {
            axios
                .get(this.getCardsURL, {params: {
                    ...this.requestParams,
                    GenerateExcelFile: true,
                }})
                .then(resp => {
                    exportToExcel(resp, 'Cards')
                })
        },
    },
    computed: {
        statusCodes() {
            return this.$store.state.statusCodes
        }
    },
}
</script>

<style scoped lang="scss">
form {
    display: flex;
    margin-bottom: 30 * $rem;

    /deep/ input,
    .switcher-container,
    .select-wrapper {
        margin-right: 15 * $rem;
    }
}
.export {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15 * $rem;

    span {
        margin-right: 15 * $rem;
    }
}
</style>